'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@twilio/operation-retrier/node_modules/core-js/internals/is-pure.js
// module id = 807
// module chunks = 25